import { addToGlobalThisRet } from "@plugins";

function popupAddFile(target) {
    const trigger = typeof target === "string" ? document.querySelector(`.${target}`) : target;
    // input type="file" клонируем и удаляем элемент,
    const photoUploadInner = trigger.querySelector(".photo-upload__inner");
    const inputBtn = trigger.querySelector(".photo-upload__label");
    if (inputBtn) {
        const templateFile = trigger.querySelector(".template-file");
        const templateFileBox = trigger.querySelector(".photo-upload__box");

        inputBtn.addEventListener("click", () => {
            const emptyInput = templateFileBox.querySelector(".photo-upload__item--hidden");
            if (emptyInput) {
                templateFileBox.children[0].remove();
            }

            // При клике на кнопку клонируем элемент
            const clone = templateFile.querySelector(".photo-upload__item").cloneNode(true);
            templateFileBox.prepend(clone);

            // После получаем инпут и кнопку для удаления
            const inputFile = trigger.querySelectorAll(".photo-upload__input");
            const templateFileBtnRemove = trigger.querySelectorAll(".photo-upload__remove");

            // Эмуляция клика на первый инпут в массиве(он всегда пустой, т.к. только склонирован из шаблона)
            inputFile[0].click();
            // Слушаем событие у первого в массиве инпута
            inputFile[0].addEventListener("change", (e) => {
                const fileType = e.target.value.split(".").pop();
                if (
                    e.target.value &&
                    (fileType === "jpg" ||
                        fileType === "png" ||
                        fileType === "svg" ||
                        fileType === "gif") &&
                    e.target.files[0].size < 5000000
                ) {
                    inputFile[0]
                        .closest(".photo-upload__item")
                        .classList.remove("photo-upload__item--hidden");
                    const fr = new FileReader();

                    fr.addEventListener(
                        "load",
                        () => {
                            trigger.querySelector(
                                ".photo-upload__item-bg",
                            ).style.backgroundImage = `url(${fr.result})`;
                            photoUploadInner.style.display = "none";
                        },
                        false,
                    );

                    fr.readAsDataURL(e.target.files[0]);
                }

                setTimeout(() => {
                    const inputFile = templateFileBox.querySelectorAll(".photo-upload__input");
                    for (let i = 0; i < inputFile.length; i++) {
                        if (inputFile[i].files.length === 0) {
                            inputFile[i].closest(".photo-upload__item").remove();
                        }
                    }
                }, 100);
            });

            // Удаляем инпут по клику
            templateFileBtnRemove.forEach((item) => {
                item.addEventListener("click", (e) => {
                    e.target.closest(".photo-upload__item").remove();
                    photoUploadInner.style.display = "block";
                });
            });
        });
    }
}

addToGlobalThisRet(popupAddFile, "popupAddFile");
